import { resolveEffectiveLanguage } from '@/utils/language';

export default {
  methods: {
    applyEffectiveLanguage() {
      const { languageCode, direction } = resolveEffectiveLanguage(
        this.$store.state.auth.userData,
        this.$store.state.settings.tenantSetting,
      );

      this.$i18n.locale = languageCode;
      document.dir = direction;
      document.documentElement.lang = languageCode;
      this.$cookies.set('currentLanguage', languageCode);
      this.$cookies.set('currentLanguageDirection', direction);
    },
  },
};
